import { connect } from 'react-redux'
import {
  closeTrainSelectModal,
} from '../actions'
import TrainSelectModal from '../components/train_positions/TrainSelectModal'

const mapStateToProps = state => {
  const { themeName } = state.themeReducer
  const { selectingTrains } = state.trainPositionReducer

  return {
    themeName,
    selectingTrains,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    closeTrainSelectModal: () => {
      dispatch(closeTrainSelectModal())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TrainSelectModal)
